module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_NHCO.b38c1ca2.jpeg";